import React from 'react';
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function CTASection() {
  const scrollToProducts = () => {
    const productsSection = document.getElementById('products-section');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#12B6B6] to-[#0ea5a5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
                Help Us Reach More Families
              </h2>
              <p className="text-xl text-white/90 leading-relaxed">
                Join thousands of supporters who are transforming lives with our 
                scientifically-backed oxygen supplementation products. Your donation helps 
                provide proper cellular oxygenation to families in need.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
                <div className="text-3xl font-bold text-white">15K+</div>
                <div className="text-sm text-white/80">Families Reached</div>
              </div>
              <div className="text-center p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
                <div className="text-3xl font-bold text-white">98%</div>
                <div className="text-sm text-white/80">Impact Rate</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/donate">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer bg-white text-[#12B6B6] hover:bg-gray-100 shadow-lg hover:shadow-xl px-8 py-4 text-lg"
                >
                  Donate to Help Families
                </button>
              </Link>
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-[#12B6B6]">
                Contact Us
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="aspect-square rounded-3xl overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/dd074b3fa4214be2c7d8a0297efc9a44.png"
                alt="Family Wellness Team"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 bg-white rounded-2xl p-4 shadow-lg">
              <div className="flex items-center space-x-2">
                <i className="ri-award-line text-[#12B6B6]"></i>
                <span className="text-sm font-medium text-[#111111]">Award Winning</span>
              </div>
            </div>
            
            <div className="absolute -bottom-4 -left-4 bg-white rounded-2xl p-4 shadow-lg">
              <div className="flex items-center space-x-2">
                <i className="ri-customer-service-2-line text-[#12B6B6]"></i>
                <span className="text-sm font-medium text-[#111111]">24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}